import projectKeys from '@/api/queries/project/keyFactory';
import timelogKeys from '@/api/queries/timelog/keyFactor';
import { Button, Modal, ModalProps } from '@payaca/ambrosia';

import { archiveTimelog } from '@payaca/store/timelogs/timelogsActions';
import { useQueryClient } from '@tanstack/react-query';
import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';

export type TProps = Pick<ModalProps, 'isOpen' | 'onClose'> & {
  timelogId?: string;
  projectId: string;
};

const DeleteTimelogModal: FC<TProps> = (props) => {
  const { isOpen, onClose, timelogId, projectId } = props;

  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [isDeletingTimelog, setIsDeletingTimelog] = useState(false);

  const handleDeleteTimelog = async () => {
    if (!timelogId) {
      return;
    }

    setIsDeletingTimelog(true);

    new Promise<void>((resolve, reject) => {
      dispatch(
        archiveTimelog.request({
          timelogPublicId: timelogId,
          callback: () => resolve(),
          onErrorCallback: (error) => reject(error),
        })
      );
    })
      .then(() => {
        void queryClient.invalidateQueries({
          queryKey: timelogKeys.list(),
        });
        void queryClient.invalidateQueries({
          queryKey: projectKeys.profitBreakdown(projectId),
        });

        onClose?.();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsDeletingTimelog(false);
      });
  };

  return (
    <Modal title="Delete Timelog" isOpen={isOpen} onClose={onClose}>
      <Modal.Body>Are you sure you want to delete this Timelog?</Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button variant="outline" onClick={() => onClose?.()}>
            Keep
          </Button>
          <Button
            colour="red"
            disabled={isDeletingTimelog}
            isProcessing={isDeletingTimelog}
            onClick={handleDeleteTimelog}
          >
            Delete
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteTimelogModal;
